import { useState } from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router";
import { lazy, Suspense } from "react";
import { RoutesConfig } from "./routes";

const Home = lazy(() => import("./views/Home"));
function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          {RoutesConfig.map(({ href, Component }) => (
            <Route key={href} path={href} element={<Component />} />
          ))}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
